import { createFileRoute } from "@tanstack/react-router";
import AdminModeratedImagesPage, {
  isBlockedFilter,
  isImageSource,
  type BlockedFilter,
} from "@/admin/pages/moderated-images";

/** The queue's filters and page, so Back out of an image lands where you were. */
export type AdminModeratedImagesSearch = {
  blocked?: BlockedFilter;
  source?: string;
  /** 1-based; absent on the first page. */
  page?: number;
};

export const Route = createFileRoute("/admin/moderated-images/")({
  component: AdminModeratedImagesPage,
  validateSearch: (search: Record<string, unknown>): AdminModeratedImagesSearch => ({
    blocked:
      isBlockedFilter(search.blocked) && search.blocked !== "blocked" ? search.blocked : undefined,
    source: isImageSource(search.source) ? search.source : undefined,
    page:
      typeof search.page === "number" && Number.isInteger(search.page) && search.page > 1
        ? search.page
        : undefined,
  }),
});
